// AUTO-GENERATED FROM scripts/data/orthopaedic-materials.csv.
// Run `node scripts/generate-orthopaedic-catalog.mjs` to regenerate.
// Do not edit by hand.

export type OrthopaedicFamily =
  | "Shells"
  | "Combined Top Cover"
  | "EVA Top Cover"
  | "PORON/PUR Top Cover"
  | "DryFeet Top Cover"
  | "Bottom Cover"
  | "Modification Accessory"
  | "EVA Block"
  | "Other Materials";

export interface OrthopaedicProduct {
  family: OrthopaedicFamily;
  /** Internal SKU, e.g. "CC-001". */
  code: string;
  productName: string;
  description: string;
  /** Purchase-option labels, in display order. */
  formats: readonly string[];
  /** Filename inside apps/web/public/products/orthopaedic-materials/. */
  image: string;
  /** True when the description carries "SPECIAL ORDER" — gets a yellow badge. */
  specialOrder: boolean;
}

export const ORTHOPAEDIC_FAMILIES: readonly OrthopaedicFamily[] = [
  "Shells",
  "Combined Top Cover",
  "EVA Top Cover",
  "PORON/PUR Top Cover",
  "DryFeet Top Cover",
  "Bottom Cover",
  "Modification Accessory",
  "EVA Block",
  "Other Materials",
];

export const ORTHOPAEDIC_PRODUCTS: readonly OrthopaedicProduct[] = [
  {
    family: "Shells",
    code: "SH-001",
    productName: "SH-001 - Semi-finish CALCA PRO X",
    description: "Semi-finished insole with fibreglass shell and integrated cushioning layer. Includes a heel cut-out for offloading and fascial accommodation from the rearfoot. Ready for top cover finishing.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-001.png",
    specialOrder: false,
  },
  {
    family: "Shells",
    code: "SH-002",
    productName: "SH-002 - Semi-finish CALCA 2",
    description: "Semi-finished insole with fibreglass shell and integrated cushioning layer. Includes a heel cut-out for offloading and plantar fascia insertion offloading. Ready for top cover finishing.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-002.png",
    specialOrder: false,
  },
  {
    family: "Shells",
    code: "SH-003",
    productName: "SH-003 - Semi-finish CALCA PRO X (no coating)",
    description: "Semi-finished insole with fibreglass shell. Includes a heel cut-out for offloading and fascial accommodation from the rearfoot. Without the first-half PORON layer, for lighter, lower-profile finishes.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-003.png",
    specialOrder: false,
  },
  {
    family: "Shells",
    code: "SH-004",
    productName: "SH-004 - Semi-finish CALCA 2 (no coating)",
    description: "Semi-finished insole with fibreglass shell. Includes a heel cut-out for offloading and plantar fascia insertion offloading. Without the first-half PORON layer, for lighter, lower-profile finishes.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-004.png",
    specialOrder: false,
  },
  {
    family: "Shells",
    code: "SH-005",
    productName: "SH-005 - CALCA PRO X shell (white fibreglass)",
    description: "Fibreglass shell only, white. Includes a heel cut-out for offloading and fascial accommodation from the rearfoot. Rigid base for fully custom orthotic builds.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-005.jpg",
    specialOrder: false,
  },
  {
    family: "Shells",
    code: "SH-006",
    productName: "SH-006 - CALCA 2 shell (white fibreglass)",
    description: "Fibreglass shell only, white. Includes a heel cut-out for offloading and plantar fascia insertion offloading. Rigid base for fully custom orthotic builds.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-006.jpg",
    specialOrder: false,
  },
  {
    family: "Shells",
    code: "SH-007",
    productName: "SH-007 - Black carbon fibre shell, anatomical geometry",
    description: "Carbon fibre shell with standard anatomical geometry. Thermo-moldable with heat. Maximum biomechanical control with minimal thickness, premium-grade rigid base.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-007.jpg",
    specialOrder: false,
  },
  {
    family: "Shells",
    code: "SH-008",
    productName: "SH-008 - Flat carbon fibre shell",
    description: "Flat carbon fibre shell, no preformed geometry. Thermo-moldable with heat, shape during fabrication. For fully custom geometries in performance and narrow footwear.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-008.jpg",
    specialOrder: false,
  },
  {
    family: "Shells",
    code: "SH-009",
    productName: "SH-009 - Blue fibreglass shell, anatomical geometry",
    description: "Fibreglass shell with standard anatomical geometry, blue. Thermo-moldable with heat. Rigid, lightweight base for sports applications and narrow footwear.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-009.jpg",
    specialOrder: false,
  },
  {
    family: "Shells",
    code: "SH-010",
    productName: "SH-010 - Flat fibreglass shell",
    description: "Flat fibreglass shell, no preformed geometry, blue. Thermo-moldable with heat, shape during fabrication. For fully custom geometries.",
    formats: [
      "Size 35",
      "Size 36",
      "Size 37",
      "Size 38",
      "Size 39",
      "Size 40",
      "Size 41",
      "Size 42",
      "Size 43",
      "Size 44",
      "Size 45",
      "Size 46",
      "Size 47",
      "Size 48",
    ],
    image: "SH-010.jpg",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-001",
    productName: "CC-001 - Anthracite DryFeet + Orange EVA Plus 20° 2mm",
    description: "Dual-layer top cover. Anthracite microperforated DryFeet over orange EVA Plus 20°. Very high resilience and tear strength.",
    formats: [
      "Sheet 120×80 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-001.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-002",
    productName: "CC-002 - Anthracite DryFeet + Green EVA Plus 20° 2mm",
    description: "Dual-layer top cover. Anthracite microperforated DryFeet over green EVA Plus 20°. Very high resilience and comfort.",
    formats: [
      "Sheet 120×80 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-002.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-003",
    productName: "CC-003 - Blue DryFeet + Green EVA Plus 20° 2mm",
    description: "Dual-layer top cover. Blue microperforated DryFeet over green EVA Plus 20°. Youthful blue/green aesthetic.",
    formats: [
      "Sheet 120×80 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-003.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-004",
    productName: "CC-004 - Beige DryFeet + Black EVA 20° 2mm",
    description: "Dual-layer top cover. Beige microperforated DryFeet over standard black EVA 20°. Comfort and reduced thickness.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-004.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-005",
    productName: "CC-005 - Black DryFeet + Black EVA 20° 2mm",
    description: "All-black dual-layer top cover. Black microperforated DryFeet over standard black EVA 20°. Discreet finish.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-005.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-006",
    productName: "CC-006 - Brown DryFeet + Beige EVA 25° 2mm",
    description: "Dual-layer top cover in warm tones. Brown microperforated DryFeet over beige EVA 25°. Aesthetic for dress footwear.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-006.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-007",
    productName: "CC-007 - Anthracite DryFeet + Red EVA Plus 20° 3mm",
    description: "Dual-layer top cover, 3mm. Anthracite microperforated DryFeet over red EVA Plus 20°. Greater comfort, athletes under moderate-high loads.",
    formats: [
      "Sheet 120×80 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-007.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-008",
    productName: "CC-008 - Brown DryFeet + Red EVA Plus 20° 3mm",
    description: "Dual-layer top cover, 3mm. Brown microperforated DryFeet over red EVA Plus 20°. Comfort and moderate propulsion.",
    formats: [
      "Sheet 120×80 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-008.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-009",
    productName: "CC-009 - Blue DryFeet + Red EVA Plus 20° 3mm",
    description: "Dual-layer top cover, 3mm. Blue microperforated DryFeet over red EVA Plus 20°. Greater comfort and resilience.",
    formats: [
      "Sheet 120×80 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-009.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-010",
    productName: "CC-010 - Black DryFeet + Black EVA 20° 3mm",
    description: "All-black dual-layer top cover, 3mm. High resilience and durability. For athletes under moderate-high loads.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-010.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-011",
    productName: "CC-011 - Black DryFeet + Yellow EVA 35° 3mm",
    description: "Dual-layer top cover with firmer EVA. Black DryFeet over yellow EVA 35°, 3mm. For athletes prioritizing support.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-011.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-012",
    productName: "CC-012 - Black DryFeet + Yellow PUR Shock Absorber 7° 3mm",
    description: "Premium top cover for maximum cushioning. Yellow PUR Shock Absorber X 7°, 3mm. Up to 90% impact absorption - diabetic foot, fasciitis.",
    formats: [
      "Sheet 140×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-012.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-013",
    productName: "CC-013 - Black DryFeet + Red PUR Slow Memory 12° 2.5mm",
    description: "Top cover with memory effect. Red PUR Slow Memory 12°, 2.5mm. For fasciitis, heel pain, metatarsalgia and diabetic foot.",
    formats: [
      "Sheet 140×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-013.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-001",
    productName: "ET-001 - Smooth Black EVA 20° 2mm",
    description: "Smooth basic EVA, black, 20° Sh.A, 2mm. Closed-cell foam, heat-moldable. Comfort with reduced thickness.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-001.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-002",
    productName: "ET-002 - Smooth Beige EVA 25° 2mm",
    description: "Smooth basic EVA, beige, 25° Sh.A, 2mm. Mid comfort with slightly firmer support than the 20°.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-002.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-003",
    productName: "ET-003 - Microperforated Beige EVA 25° 2mm",
    description: "Microperforated EVA top cover, beige, 25° Sh.A, 2mm. Perforations improve breathability. Heat-moldable closed-cell foam for insoles needing greater ventilation in a reduced profile. Precut sizes: Small 31×12 cm (EU 24-44), Large 34×14 cm (EU 45-48).",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-003.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-004",
    productName: "ET-004 - Smooth Blue EVA 35° 2mm",
    description: "Smooth basic EVA, blue, 35° Sh.A, 2mm. Firmer closed-cell foam with good resilience and durability.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-004.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-005",
    productName: "ET-005 - Smooth Black EVA 35° 2mm",
    description: "Smooth basic EVA, black, 35° Sh.A, 2mm. Firmer closed-cell foam, good resilience.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-005.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-006",
    productName: "ET-006 - Smooth Beige EVA 35° 2mm",
    description: "Smooth basic EVA, beige, 35° Sh.A, 2mm. Discreet finish for dress footwear, easy to clean.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-006.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-007",
    productName: "ET-007 - Smooth Black EVA 35° 3mm",
    description: "Smooth basic EVA, black, 35° Sh.A, 3mm. Greater thickness and firmness for durability.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-007.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-008",
    productName: "ET-008 - Smooth Beige EVA 35° 3mm",
    description: "Smooth basic EVA, beige, 35° Sh.A, 3mm. Greater thickness with discreet tone.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-008.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-009",
    productName: "ET-009 - Pink Marbled EVA 35° 3mm",
    description: "Pink marbled EVA, 35° Sh.A, 3mm. Decorative finish, especially attractive for pediatric insoles.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-009.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-010",
    productName: "ET-010 - Blue Marbled EVA 35° 3mm",
    description: "Blue marbled EVA, 35° Sh.A, 3mm. Decorative finish for pediatric, sports or branded insoles.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-010.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-011",
    productName: "ET-011 - Red Marbled EVA 35° 3mm",
    description: "Red marbled EVA, 35° Sh.A, 3mm. Decorative finish for pediatric, sports or branded insoles.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-011.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-012",
    productName: "ET-012 - Orange EVA Plus 30° 3mm",
    description: "Technical EVA Plus, orange, 30° Sh.A, 3mm. 90% EVA / 10% SBR. Very high resilience and propulsion for athletes.",
    formats: [
      "Sheet 200×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-012.png",
    specialOrder: false,
  },
  {
    family: "EVA Top Cover",
    code: "ET-013",
    productName: "ET-013 - Cobalt Blue EVA Plus 30° 3mm",
    description: "Technical EVA Plus, cobalt blue, 30° Sh.A, 3mm. 90% EVA / 10% SBR. Very high resilience, high mechanical demand.",
    formats: [
      "Sheet 200×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "ET-013.png",
    specialOrder: false,
  },
  {
    family: "PORON/PUR Top Cover",
    code: "PU-001",
    productName: "PU-001 - Red PUR Slow Memory 12° 3mm",
    description: "PORON/PUR Slow-Memory, red, 12° Sh.A, 3mm. Open-cell antibacterial foam with memory effect. For offloading.",
    formats: [
      "Sheet 140×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "PU-001.png",
    specialOrder: false,
  },
  {
    family: "PORON/PUR Top Cover",
    code: "PU-002",
    productName: "PU-002 - Red PUR Slow Memory 12° 4.5mm",
    description: "PORON/PUR Slow-Memory, red, 12° Sh.A, 4.5mm. Open-cell antibacterial foam with adaptive memory effect.",
    formats: [
      "Sheet 140×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "PU-002.png",
    specialOrder: false,
  },
  {
    family: "PORON/PUR Top Cover",
    code: "PU-003",
    productName: "PU-003 - Yellow PUR Shock Absorber 7° 3mm",
    description: "PORON/PUR Shock Absorber X, yellow, 7° Sh.A, 3mm. Absorbs up to 90% impact energy. Diabetic foot, fasciitis, offloading.",
    formats: [
      "Sheet 140×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "PU-003.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-001",
    productName: "DF-001 - Microperforated DryFeet, Beige, 0.8mm",
    description: "DryFeet microfiber, microperforated, beige, 0.8mm. Breathable, hypoallergenic, antibacterial. Premium surface finish.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-001.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-002",
    productName: "DF-002 - Microperforated DryFeet, Navy Blue, 0.8mm",
    description: "DryFeet microfiber, microperforated, navy blue, 0.8mm. Breathable, antibacterial. Leather-like feel.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-002.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-003",
    productName: "DF-003 - Microperforated DryFeet, Brown, 0.8mm",
    description: "DryFeet microfiber, microperforated, brown, 0.8mm. Breathable. Warm discreet tone.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-003.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-004",
    productName: "DF-004 - Microperforated DryFeet, Anthracite, 0.8mm",
    description: "DryFeet microfiber, microperforated, anthracite, 0.8mm. Breathable, antibacterial. Modern discreet tone.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-004.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-005",
    productName: "DF-005 - Microperforated DryFeet, Black, 0.8mm",
    description: "DryFeet microfiber, microperforated, black, 0.8mm. Breathable, antibacterial. Premium black surface finish.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-005.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-006",
    productName: "DF-006 - Smooth DryFeet, Beige, 0.8mm",
    description: "DryFeet microfiber, smooth (non-perforated), beige, 0.8mm. Leather-like look and feel, antibacterial.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-006.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-007",
    productName: "DF-007 - Smooth DryFeet, Navy Blue, 0.8mm",
    description: "DryFeet microfiber, smooth, navy blue, 0.8mm. Leather look, antibacterial.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-007.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-008",
    productName: "DF-008 - Smooth DryFeet, Aqua Blue, 0.8mm",
    description: "DryFeet microfiber, smooth, aqua blue, 0.8mm. Vibrant blue, leather look, antibacterial.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-008.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-009",
    productName: "DF-009 - Smooth DryFeet, Red, 0.8mm",
    description: "DryFeet microfiber, smooth, red, 0.8mm. Bold red color, leather look. Strong visual identity.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-009.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-010",
    productName: "DF-010 - Smooth DryFeet, Anthracite, 0.8mm",
    description: "DryFeet microfiber, smooth, anthracite, 0.8mm. Modern discreet anthracite, leather look.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-010.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-011",
    productName: "DF-011 - Smooth DryFeet, Black, 0.8mm",
    description: "DryFeet microfiber, smooth, black, 0.8mm. Black leather look, antibacterial.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-011.png",
    specialOrder: false,
  },
  {
    family: "DryFeet Top Cover",
    code: "DF-012",
    productName: "DF-012 - Smooth DryFeet, Brown, 0.8mm",
    description: "DryFeet microfiber, smooth, brown, 0.8mm. Warm brown tone, leather look.",
    formats: [
      "Roll 12 cm × 50 m",
    ],
    image: "DF-012.png",
    specialOrder: false,
  },
  {
    family: "Bottom Cover",
    code: "BC-001",
    productName: "BC-001 - Black Carbotec 0.9mm",
    description: "Carbotec bottom cover, black, 0.9mm. Carbon-fiber look. High tear resistance, easy to clean.",
    formats: [
      "Mini Roll 12 cm × 50 m",
    ],
    image: "BC-001.png",
    specialOrder: false,
  },
  {
    family: "Bottom Cover",
    code: "BC-002",
    productName: "BC-002 - Titanium Carbotec 0.9mm",
    description: "Carbotec bottom cover, titanium, 0.9mm. Carbon-fiber look. High tear resistance, easy to clean.",
    formats: [
      "Mini Roll 12 cm × 50 m",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "BC-002.png",
    specialOrder: false,
  },
  {
    family: "Bottom Cover",
    code: "BC-003",
    productName: "BC-003 - Black Anti-Slip EVA 55° 1.1mm",
    description: "Anti-slip EVA bottom cover, black, 55° Sh.A, 1.1mm. High friction and tear resistance, heat-moldable.",
    formats: [
      "Sheet 140×80 cm",
      "Precut Pair (16×12.5 cm)",
    ],
    image: "BC-003.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-001",
    productName: "MA-001 - Posting EVA, Black 65° 2mm",
    description: "Hard EVA for posting, smooth black, 65° Sh.A, 2mm. High-density closed-cell foam. For posting, lifts and supplements. Sold per sheet.",
    formats: [
      "Sheet 90×170 cm",
    ],
    image: "MA-001.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-002",
    productName: "MA-002 - Posting EVA, Black 65° 3mm",
    description: "Hard EVA for posting, smooth black, 65° Sh.A, 3mm. High-density closed-cell foam. For posting and lifts. Sold per sheet.",
    formats: [
      "Sheet 90×170 cm",
    ],
    image: "MA-002.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-003",
    productName: "MA-003 - Posting EVA, Black 65° 5mm",
    description: "Hard EVA for posting, smooth black, 65° Sh.A, 5mm. For medium lifts and supplements. Sold per sheet.",
    formats: [
      "Sheet 90×170 cm",
    ],
    image: "MA-003.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-004",
    productName: "MA-004 - Posting EVA, Black 65° 7mm",
    description: "Hard EVA for posting, smooth black, 65° Sh.A, 7mm. For long lifts and greater height supplements. Sold per sheet.",
    formats: [
      "Sheet 90×170 cm",
    ],
    image: "MA-004.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-005",
    productName: "MA-005 - Posting EVA, Black 65° 10mm",
    description: "Hard EVA for posting, smooth black, 65° Sh.A, 10mm. Maximum thickness for significant limb-length discrepancies. Sold per sheet.",
    formats: [
      "Sheet 90×170 cm",
    ],
    image: "MA-005.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-006",
    productName: "MA-006 - Anatomical Metatarsal Bar T1 - 3mm",
    description: "Anatomical metatarsal bar, Size 1, max 3mm. Carbosan 10°/15° foam. Moderate metatarsal support.",
    formats: [
      "Pair",
    ],
    image: "MA-006.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-007",
    productName: "MA-007 - Anatomical Metatarsal Bar T2 - 6mm",
    description: "Anatomical metatarsal bar, Size 2, max 6mm. Carbosan 10°/15° foam. Intermediate metatarsal offloading.",
    formats: [
      "Pair",
    ],
    image: "MA-007.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-008",
    productName: "MA-008 - Metatarsal Dome T1",
    description: "Symmetrical metatarsal dome, Size 1, max 7mm. Carbosan 10°/15° foam. Targeted metatarsal support.",
    formats: [
      "Pair",
    ],
    image: "MA-008.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-009",
    productName: "MA-009 - Metatarsal Dome T2",
    description: "Symmetrical metatarsal dome, Size 2, max 7mm. Carbosan 10°/15° foam.",
    formats: [
      "Pair",
    ],
    image: "MA-009.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-010",
    productName: "MA-010 - Metatarsal Dome T3",
    description: "Symmetrical metatarsal dome, Size 3, max 8mm. Carbosan 10°/15° foam. Advanced cases.",
    formats: [
      "Pair",
    ],
    image: "MA-010.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-011",
    productName: "MA-011 - Full Metatarsal Offloading Pad M1-M5 - 3mm",
    description: "Full metatarsal offloading pad M1-M5, 3mm. Carbosan 10°/15° foam with antibacterial activated carbon.",
    formats: [
      "Pair",
    ],
    image: "MA-011.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-012",
    productName: "MA-012 - Anatomical Heel Offloading Pad T1 - 2.5mm",
    description: "Anatomical heel offloading pad, Size 1, max 2.5mm. Carbosan 10°/15° antibacterial foam.",
    formats: [
      "Pair",
    ],
    image: "MA-012.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-013",
    productName: "MA-013 - Anatomical Heel Offloading Pad T2 - 3mm",
    description: "Anatomical heel offloading pad, Size 2, max 3mm. Carbosan 10°/15° antibacterial foam.",
    formats: [
      "Pair",
    ],
    image: "MA-013.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-014",
    productName: "MA-014 - Central High-Heel Metatarsal Offloading Pad - 3mm",
    description: "Central metatarsal offloading pad for Daily² High Heel insoles, 3mm. Carbosan antibacterial foam.",
    formats: [
      "Pair",
    ],
    image: "MA-014.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-015",
    productName: "MA-015 - Central Metatarsal + Heel PUR 7° Offloading Set (35-48)",
    description: "Set of central metatarsal + heel offloading pads, 3mm, sizes 35-48. PORON/PUR Shock Absorber X yellow 7° Sh.A.",
    formats: [
      "Pair Set",
    ],
    image: "MA-015.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-016",
    productName: "MA-016 - TPU Posted Heel Wedge (35-38)",
    description: "TPU posted heel wedge with 4mm elevation, sizes 35-38. For heel lifts, dismetrías, inversions and eversions.",
    formats: [
      "Pair",
    ],
    image: "MA-016.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-017",
    productName: "MA-017 - TPU Posted Heel Wedge (39-41)",
    description: "TPU posted heel wedge with 4mm elevation, sizes 39-41. For heel lifts, dismetrías, inversions and eversions.",
    formats: [
      "Pair",
    ],
    image: "MA-017.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-018",
    productName: "MA-018 - TPU Posted Heel Wedge (42-44)",
    description: "TPU posted heel wedge with 4mm elevation, sizes 42-44. For heel lifts, dismetrías, inversions and eversions.",
    formats: [
      "Pair",
    ],
    image: "MA-018.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-019",
    productName: "MA-019 - TPU Posted Heel Wedge (45-48)",
    description: "TPU posted heel wedge with 4mm elevation, sizes 45-48. For heel lifts, dismetrías, inversions and eversions.",
    formats: [
      "Pair",
    ],
    image: "MA-019.png",
    specialOrder: false,
  },
  {
    family: "Modification Accessory",
    code: "MA-020",
    productName: "MA-020 - Daily² Comfort Cushioning Insole (35-48)",
    description: "Daily² Comfort cushioning insole, sizes 35-48. Variable thickness 0 to 2.5mm progressive. Carbosan 10°/15° foam.",
    formats: [
      "Pair (specify size 35-48)",
    ],
    image: "MA-020.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-001",
    productName: "EB-001 - Beige Wedge Block, Dual-Density 25°",
    description: "Dual-density EVA block, wedge format, beige/black. Block 25° Sh.A, bottom 1.5mm at 55°. Geriatric, diabetic, fasciopathies, comfort.",
    formats: [
      "Block 350×260×30/10 mm",
    ],
    image: "EB-001.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-002",
    productName: "EB-002 - Green Wedge Block, Dual-Density 25°",
    description: "Dual-density EVA block, wedge format, green/black. Block 25° Sh.A, bottom 1.5mm at 55°. Geriatric, diabetic, comfort.",
    formats: [
      "Block 350×260×30/10 mm",
    ],
    image: "EB-002.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-003",
    productName: "EB-003 - Camel Brown Wedge Block, Dual-Density 30°",
    description: "Dual-density EVA block, wedge format, camel/dark brown. Block 30° Sh.A. Pronation/supination, pediatric, comfort.",
    formats: [
      "Block 350×260×30/10 mm",
    ],
    image: "EB-003.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-004",
    productName: "EB-004 - Navy Blue Wedge Block, Dual-Density 40°",
    description: "Dual-density EVA block, wedge format, navy/black. Block 40° Sh.A. Pronation/supination, sport, rearfoot control.",
    formats: [
      "Block 350×260×30/10 mm",
    ],
    image: "EB-004.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-005",
    productName: "EB-005 - Red Wedge Block, Dual-Density 40°",
    description: "Dual-density EVA block, wedge format, red/black. Block 40° Sh.A. Pronation/supination, sport, rearfoot control.",
    formats: [
      "Block 350×260×30/10 mm",
    ],
    image: "EB-005.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-006",
    productName: "EB-006 - Green/Gray Wedge Block, Tri-Density V25°/G45°",
    description: "Tri-density EVA block, wedge format, gray/green/black. Combined V25°/G45°. Premium for pronation/supination, sport, pediatric.",
    formats: [
      "Block 350×260×30/10 mm",
    ],
    image: "EB-006.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-007",
    productName: "EB-007 - Camel Brown Rectangular Block, Dual-Density 30°",
    description: "Dual-density EVA block, rectangular, brown/dark brown. Block 30° Sh.A. Pronation/supination, comfort, pediatric, amputations.",
    formats: [
      "Block 350×260×33 mm",
    ],
    image: "EB-007.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-008",
    productName: "EB-008 - Navy Blue Rectangular Block, Dual-Density 40°",
    description: "Dual-density EVA block, rectangular, navy/black. Block 40° Sh.A. Pronation/supination, sport, rearfoot control.",
    formats: [
      "Block 350×260×33 mm",
    ],
    image: "EB-008.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-009",
    productName: "EB-009 - Red Rectangular Block, COMBI EVA 40°",
    description: "Dual-density COMBI EVA block, rectangular, red/black. Block 40° Sh.A. Pronation/supination, rearfoot control, pediatric.",
    formats: [
      "Block 350×260×33 mm",
    ],
    image: "EB-009.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-010",
    productName: "EB-010 - Navy/Gray Rectangular Block, COMBI EVA M30°/G55°",
    description: "Dual-density COMBI EVA block, rectangular, gray/navy/black. Combined M30°/G55° Sh.A. Progressive hardness for sport.",
    formats: [
      "Block 350×260×33 mm",
    ],
    image: "EB-010.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-011",
    productName: "EB-011 - Gray Rectangular Block, Single-Density 60°",
    description: "Single-density EVA block, rectangular, gray. Block 60° Sh.A (high firmness), no bottom layer. Uniform firmness for control.",
    formats: [
      "Block 350×260×33 mm",
    ],
    image: "EB-011.png",
    specialOrder: false,
  },
  {
    family: "EVA Block",
    code: "EB-012",
    productName: "EB-012 - Pink Rectangular Block, Rigid PUR",
    description: "Rigid PUR rectangular block, pink. Material for the fabrication of positives in the milled-insole process.",
    formats: [
      "Block 350×260×40 mm",
    ],
    image: "EB-012.png",
    specialOrder: false,
  },
  {
    family: "Combined Top Cover",
    code: "CC-014",
    productName: "CC-014 - Beige DryFeet + Black EVA 20° 3mm",
    description: "Dual-layer top cover. Beige microperforated DryFeet over standard black EVA 20°, 3mm. Extra cushioning and comfort.",
    formats: [
      "Sheet 210×100 cm",
      "Precut Pair (EU 24-44)",
      "Precut Pair (EU 45-48)",
    ],
    image: "CC-004.png",
    specialOrder: false,
  },
  {
    family: "Other Materials",
    code: "FOAM-BOX",
    productName: "FOAM-BOX - Phenolic Foam Impression Box",
    description: "Phenolic foam impression box for taking foot impressions. Sold per unit.",
    formats: [
      "Unit (box)",
    ],
    image: "foam-box.png",
    specialOrder: false,
  },
];

export const ORTHOPAEDIC_IMAGE_BASE = '/products/orthopaedic-materials';
